/**
 * Suspend scroll-snap on cssMode carousels while the PAGE scrolls vertically.
 *
 * The touch carousels run in Swiper's cssMode (native horizontal scroll +
 * `scroll-snap-type: x mandatory` on the wrapper — see
 * client-testimonials-swiper.js for why). On iOS, scrolling the page makes
 * the browser toolbar collapse/expand, which changes the viewport geometry
 * every frame — and each change makes WebKit re-evaluate the mandatory snap
 * on every nested horizontal scroller. With fractional slide widths (the
 * cards are vw-sized), that re-evaluation oscillates between two candidate
 * snap targets, so a carousel that isn't at scroll position 0 visibly
 * jitters left-right the whole time the page is moving.
 *
 * A horizontal carousel swipe and a vertical page scroll can't physically
 * happen at the same time, so snapping is pure dead weight during page
 * scroll: turn it off on the first page-scroll event and restore it shortly
 * after scrolling settles. Element scroll events don't bubble, so the
 * window listener only ever fires for page scrolling — a horizontal swipe
 * inside a carousel never disables its own snap.
 */
const RESTORE_DELAY_MS = 250;

export function initCssModeSnapGuard() {
	let timer = 0;
	let suspended = false;

	const wrappers = () => document.querySelectorAll('.swiper-css-mode > .swiper-wrapper');

	const suspend = () => {
		if (!suspended) {
			suspended = true;
			wrappers().forEach((wrapper) => {
				wrapper.style.scrollSnapType = 'none';
			});
		}
		window.clearTimeout(timer);
		timer = window.setTimeout(restore, RESTORE_DELAY_MS);
	};

	const restore = () => {
		suspended = false;
		wrappers().forEach((wrapper) => {
			// Back to the stylesheet value (Swiper's `x mandatory`).
			wrapper.style.scrollSnapType = '';
		});
	};

	window.addEventListener('scroll', suspend, { passive: true });
}
